import { render } from "./ModifyUserIntroduce.vue?vue&type=template&id=2a87118a&scoped=true"
import script from "./ModifyUserIntroduce.vue?vue&type=script&lang=js"
export * from "./ModifyUserIntroduce.vue?vue&type=script&lang=js"

import "./ModifyUserIntroduce.vue?vue&type=style&index=0&id=2a87118a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a87118a"]])

export default __exports__